import axios from 'axios'
import {API} from 'src/feature/bite/domain'

interface MerchantForm {
  merchantID: string
  name: string
  surname: string
  email: string
  phone: string
  titleID: string
}

interface MerchantResponse {
  response: {
    groupId: string
    chainId: string
    storeId: string
    mailSend: boolean
  }
  responseResult: {
    result: boolean
    exceptionDetail: string
  }
}

export default async function submitForm(merchantForm: MerchantForm) {
  const response = await axios.post<MerchantResponse>(
    `${API}/Merchant/BecomeAMerchantUpdateInformation`,
    merchantForm
  )
  if (response.data.responseResult.result) {
    return {
      status: true,
      message: 'Success',
    }
  } else {
    return {
      status: false,
      message: response.data.responseResult.exceptionDetail,
    }
  }
}
